// This file was automatically generated from signup.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.signup');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.physicianNamesSelection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.intendedPhysician) {
    if (opt_data.otherCanonicalPhysicians.length >= 5) {
      el8.template.multiuser_access.signup.physicianNamesSelectionAsDropDown(opt_data, output);
    } else {
      el8.template.multiuser_access.signup.physicianNamesSelectionAsRadioButtons(opt_data, output);
    }
  } else {
    if (opt_data.otherCanonicalPhysicians.length >= 6) {
      el8.template.multiuser_access.signup.physicianNamesSelectionAsDropDown(opt_data, output);
    } else {
      el8.template.multiuser_access.signup.physicianNamesSelectionAsRadioButtons(opt_data, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.physicianNamesSelectionAsDropDown = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<select class="el8StandardInput" name="physicianId">', (opt_data.intendedPhysician) ? '<option value="' + soy.$$escapeHtml(opt_data.intendedPhysician.id) + '">' + soy.$$escapeHtml(opt_data.intendedPhysician.name) + '</option>' : '');
  var canPhyList183 = opt_data.otherCanonicalPhysicians;
  var canPhyListLen183 = canPhyList183.length;
  for (var canPhyIndex183 = 0; canPhyIndex183 < canPhyListLen183; canPhyIndex183++) {
    var canPhyData183 = canPhyList183[canPhyIndex183];
    output.append('<option value="', soy.$$escapeHtml(canPhyData183.id), '">', soy.$$escapeHtml(canPhyData183.name), '</option>');
  }
  output.append('<option value="">Other</option></select>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.physicianNamesSelectionAsRadioButtons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.intendedPhysician) ? '<label class="el8Radio"><input name="physicianId" type="radio" value="' + soy.$$escapeHtml(opt_data.intendedPhysician.id) + '"></input>' + soy.$$escapeHtml(opt_data.intendedPhysician.name) + '</label>' : '');
  var canPhyList199 = opt_data.otherCanonicalPhysicians;
  var canPhyListLen199 = canPhyList199.length;
  for (var canPhyIndex199 = 0; canPhyIndex199 < canPhyListLen199; canPhyIndex199++) {
    var canPhyData199 = canPhyList199[canPhyIndex199];
    output.append('<label class="el8Radio"><input name="physicianId" type="radio" value="', soy.$$escapeHtml(canPhyData199.id), '"></input>', soy.$$escapeHtml(canPhyData199.name), '</label>');
  }
  output.append('<label class="el8Radio"><input name="physicianId" type="radio" value=""></input>Other</label>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.physicianNamesChooser = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Row el8FormGroup" id="signup-physician-chooser-container"><label class="el8StandardInputLabel el8Col5">My name is</label><div class="el8Col6" id="signup-physician-selection-container"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.signupName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Row el8FormGroup" id="signup-name-container"><label class="el8StandardInputLabel el8Col5">Write your name</label><div class="el8Col3"><input type="text" class="el8StandardInput" name="firstName" placeholder="First Name"></input></div><div class="el8Col3"><input type="text" class="el8StandardInput" name="lastName" placeholder="Last Name"></input></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.designation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Row el8FormGroup" id="signup-designation-container"><label class="el8StandardInputLabel el8Col5">Choose your designation</label><div class="el8Col6"><select name="designation" class="el8StandardInput"><option>MD</option><option>DO</option><option>RN</option><option>PT</option><option>NP</option><option>PA</option><option value="">Other</option></select></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.passwordHelp = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="password-help el8Popover el8PasswordCheck right"><div class="el8PopoverArrow"></div><div class="el8PopoverContent"><p class="el8Bold">Your password must:</p><ul class="el8ValidationChecklist noMargin"><li id="min-number-char" >Be at least 8 characters long</li><li id="at-least-one-number-or-special-char">Have at least 1 number or special character</li></ul></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.passwordMatch = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="password-match el8Popover el8PasswordMatch right"><div class="el8PopoverArrow"></div><div class="el8PopoverContent"><p class="el8Red el8Bold noMargin">Passwords do not match.</p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.password = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Row el8FormGroup"><label class="el8StandardInputLabel el8Col5">Create a password</label><div class="el8Col6"><input type="password" name="password1" class="el8StandardInput"></input></div><div class="el8Col1 el8Relative"><span class="el8HelpIcon password-icon el8IconMtSm el8IconMlLg"></span>');
  el8.template.multiuser_access.signup.passwordHelp(null, output);
  output.append('</div></div><div class="el8Row el8FormGroup"><label class="el8StandardInputLabel el8Col5">Enter password again</label><div class="el8Col6"><input type="password" name="password2" class="el8StandardInput"></input></div><div class="el8Col1 el8Relative">');
  el8.template.multiuser_access.signup.passwordMatch(null, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.securityQA = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Row el8FormGroup"><label class="el8StandardInputLabel el8Col5">Choose a security question</label><div class="el8Col6"><select class="el8StandardInput" name="question" ><option value="">-- choose a question --</option>');
  var qList225 = opt_data.securityQuestions;
  var qListLen225 = qList225.length;
  for (var qIndex225 = 0; qIndex225 < qListLen225; qIndex225++) {
    var qData225 = qList225[qIndex225];
    output.append('<option>', soy.$$escapeHtml(qData225), '</option>');
  }
  output.append('</select></div><div class="el8Col1"><span class="el8HelpIcon securityQ-icon el8IconMtSm el8IconMlLg"></span></div></div><div class="el8Row el8FormGroup"><label class="el8StandardInputLabel el8Col5">Answer to security question</label><div class="el8Col6"><input type="text" class="el8StandardInput" name="answer" ></input></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><form id="main-form"><h3 class="el8BrandColor el8LightWeight el8AlignCenter">View charts sent to your practice via Elation</h3><div class="el8MdSpacer"></div><div class="el8FormHorizontal el8FaxSignupForm"><h5 class="el8AlignCenter">Per HIPAA requirements, we just need a little information about you.</h5><div class="el8Row el8FormGroup"><label class="el8StandardInputLabel el8Col5">My role in the practice is</label><div class="el8Col6"><label class="el8RadioInline"><input name="role" type="radio" value="clinician"></input>Provider</label><label class="el8RadioInline"><input name="role" type="radio" value="staff"></input>Office Staff</label></div></div><div class="detail-container">');
  el8.template.multiuser_access.signup.physicianNamesChooser(opt_data, output);
  el8.template.multiuser_access.signup.signupName(opt_data, output);
  el8.template.multiuser_access.signup.designation(opt_data, output);
  output.append('<div class="el8SmSpacer"></div>');
  el8.template.multiuser_access.signup.password(opt_data, output);
  el8.template.multiuser_access.signup.securityQA(opt_data, output);
  output.append('</div></div><!-- el8FormHorizontal --><div class="el8MdSpacer"></div><div class="el8AlignCenter detail-container"><p>By clicking below, I agree to the <a class="eula-link" href="">Elation Terms and Conditions</a></p><button id="go-to-chart" class="el8Btn el8BtnPrimary">Agree and Go to Chart</button></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.passwordTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div style="font-size:12px;padding:5px;line-height:14px;"><b>Why do I need to set a password?</b><br><br>When you come back to Elation to view patient charts, we\'ll have you enter your password to confirm that it\'s really you logging in.</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signup.securityQTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div style="font-size:12px;padding:5px;line-height:14px;"><b>What is the security question for?</b><br><br>If you ever forget your password, we\'ll ask you to answer your security question before you can reset your password.</div>');
  if (!opt_sb) return output.toString();
};
